// src/components/ClientPortalSidebar.js

import React from 'react';

export default function ClientPortalSidebar({ 
    isOpen, 
    onClose, 
    onOpen,
    activeTab, 
    setActiveTab, 
    portalUser, 
    stats, 
    contracts, 
    reports, 
    assets, 
    equipmentList,
    onLogout
}) {
    const spanClass = "font-medium whitespace-nowrap overflow-hidden transition-all duration-300 opacity-100 lg:opacity-0 lg:group-hover:opacity-100 lg:max-w-0 lg:group-hover:max-w-[200px] ml-3 lg:ml-0 lg:group-hover:ml-3";
    const headerClass = "px-3 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2 whitespace-nowrap overflow-hidden transition-all duration-300 opacity-100 lg:opacity-0 lg:group-hover:opacity-100 lg:max-w-0 lg:group-hover:max-w-[200px]";
    const btnClass = "flex items-center justify-center lg:group-hover:justify-start w-full px-0 lg:group-hover:px-3 py-3 mb-2 rounded-xl transition-all duration-300 relative";

    const badgeClass = "absolute right-2 top-1/2 -translate-y-1/2 text-[9px] px-1.5 py-0.5 rounded-full font-mono transition-all duration-300 opacity-100 lg:opacity-0 lg:group-hover:opacity-100";

    return (
        <>
            {/* Mobile Header (somente visível em telas pequenas) */}
            <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-slate-900/90 backdrop-blur-md border-b border-white/10 z-30 flex justify-between items-center px-4">
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-gradient-to-tr from-cyan-600 to-cyan-400 flex items-center justify-center font-black text-white shadow-lg">A</div>
                    <span className="font-bold text-white">Área do Cliente</span>
                </div>
                <button onClick={onOpen} className="p-2 text-slate-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            </div>

            {/* Overlay mobile */}
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={onClose}></div>
            )}

            <aside className={`fixed inset-y-0 left-0 bg-slate-900 border-r border-slate-800 lg:bg-slate-900/50 lg:backdrop-blur-2xl lg:border lg:border-white/10 lg:rounded-[2rem] lg:top-4 lg:bottom-4 lg:left-4 z-50 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 transition-[width,transform] duration-300 ease-in-out flex flex-col group w-64 lg:w-[76px] lg:hover:w-[260px] flex-shrink-0 shadow-2xl overflow-hidden`}>
                
                <div className="p-4 py-6 border-b border-white/10 flex justify-between items-center whitespace-nowrap h-[81px]">
                    <div className="flex items-center">
                        <div className="w-8 h-8 flex-shrink-0 bg-cyan-500 rounded-lg flex items-center justify-center font-bold text-white shadow-lg shadow-cyan-500/20 ml-[6px]">A</div>
                        <h2 className="ml-3 text-xl font-bold text-white tracking-tight opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-300 lg:max-w-0 lg:group-hover:max-w-[200px] overflow-hidden">Portal Arcus</h2>
                    </div>
                    <button onClick={onClose} className="lg:hidden flex-shrink-0 text-slate-400 hover:text-white ml-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                </div>

                <nav className="flex-1 p-4 overflow-x-hidden overflow-y-auto lg:[&:not(:hover)]:overflow-hidden custom-scrollbar transition-all">
                    
                    <button 
                        onClick={() => { setActiveTab('tickets'); onClose(); }} 
                        className={`${btnClass} ${activeTab === 'tickets' ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/20' : 'hover:bg-slate-700 text-slate-300'}`}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 012-2h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5z" />
                        </svg>
                        <span className={spanClass}>
                            {portalUser.role === 'User Company' ? 'Chamados da Empresa' : 'Meus Chamados'}
                        </span>
                        <span className={`${badgeClass} ${activeTab === 'tickets' ? 'bg-cyan-600 text-white' : 'bg-slate-800 text-slate-300'}`}>
                            {stats.open}
                        </span>
                    </button>

                    <button 
                        onClick={() => { setActiveTab('company'); onClose(); }} 
                        className={`${btnClass} ${activeTab === 'company' ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/20' : 'hover:bg-slate-700 text-slate-300'}`}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                        <span className={spanClass}>Dados da Empresa</span>
                    </button>

                    {portalUser.role === 'User Company' && (
                        <>
                            <div className="my-4 border-t border-white/5 pt-4">
                                <p className={headerClass}>Módulos</p>
                                
                                {portalUser.modules?.contracts && (
                                    <button 
                                        onClick={() => { setActiveTab('contracts'); onClose(); }} 
                                        className={`${btnClass} ${activeTab === 'contracts' ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/20' : 'hover:bg-slate-700 text-slate-300'}`}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <span className={spanClass}>Gestão do Contrato</span>
                                        <span className={`${badgeClass} ${activeTab === 'contracts' ? 'bg-cyan-600 text-white' : 'bg-slate-800 text-slate-300'}`}>
                                            {contracts.length}
                                        </span>
                                    </button>
                                )}

                                {portalUser.modules?.reports && (
                                    <button 
                                        onClick={() => { setActiveTab('reports'); onClose(); }} 
                                        className={`${btnClass} ${activeTab === 'reports' ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/20' : 'hover:bg-slate-700 text-slate-300'}`}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <span className={spanClass}>Laudos Técnicos</span>
                                        <span className={`${badgeClass} ${activeTab === 'reports' ? 'bg-cyan-600 text-white' : 'bg-slate-800 text-slate-300'}`}>
                                            {reports.length}
                                        </span>
                                    </button>
                                )}

                                {portalUser.modules?.assets && (
                                    <button 
                                        onClick={() => { setActiveTab('assets'); onClose(); }} 
                                        className={`${btnClass} ${activeTab === 'assets' ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/20' : 'hover:bg-slate-700 text-slate-300'}`}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                        <span className={spanClass}>Dispositivos</span>
                                        <span className={`${badgeClass} ${activeTab === 'assets' ? 'bg-cyan-600 text-white' : 'bg-slate-800 text-slate-300'}`}>
                                            {assets.length}
                                        </span>
                                    </button>
                                )}

                                {portalUser.modules?.inventory && (
                                    <button 
                                        onClick={() => { setActiveTab('inventory'); onClose(); }} 
                                        className={`${btnClass} ${activeTab === 'inventory' ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/20' : 'hover:bg-slate-700 text-slate-300'}`}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                        </svg>
                                        <span className={spanClass}>Inventário</span>
                                        <span className={`${badgeClass} ${activeTab === 'inventory' ? 'bg-cyan-600 text-white' : 'bg-slate-800 text-slate-300'}`}>
                                            {equipmentList.length}
                                        </span>
                                    </button>
                                )}
                            </div>
                        </>
                    )}
                </nav>

                <div className="p-4 border-t border-white/10 bg-slate-800/50 lg:bg-transparent overflow-hidden">
                    <div className="px-3 mb-4 flex flex-col items-center lg:group-hover:items-start transition-all">
                        <p className={headerClass}>Sessão</p>
                        <p className={`text-[10px] text-cyan-400 font-bold uppercase truncate ${spanClass}`}>
                            {portalUser.role === 'User Company' ? 'Gestor' : 'Colaborador'}
                        </p>
                        <p className={`text-xs text-slate-300 truncate font-medium ${spanClass}`}>{portalUser.email}</p>
                    </div>
                    <button onClick={onLogout} className="flex items-center justify-center lg:group-hover:justify-start w-full px-0 lg:group-hover:px-3 py-3 text-sm font-bold rounded-xl text-white bg-red-600/80 hover:bg-red-600 transition-all uppercase tracking-widest">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                        <span className={spanClass}>Sair</span>
                    </button>
                </div>
            </aside>
            {/* Espaçador invisível para empurrar o conteúdo na versão desktop */}
            <div className="hidden lg:block w-[108px] flex-shrink-0 transition-[width] duration-300"></div>
        </>
    );
}
